import React, { Component } from 'react';
import { Form,Button } from 'react-bootstrap';
import './main.css';
import Logo from '../../Helper/Logo/logo';
import {routeName} from '../../../src/Service/env';
import bg from '../../images/landing-bg.png';

class Main extends Component {

    onLogin=()=>{
        this.props.history.push(`/${routeName}/Login`);
    };

    onSignup=()=>{
        this.props.history.push(`/${routeName}/Signup`);
    };

    render(){
        return(
            <Form>
                <section className="landing-page" style={{backgroundImage:bg}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <section className="main-white-box">
                                    <a href="" className="overlay-logo">
                                        <Logo/>
                                    </a>
                                    <div className="col-12 text-center mt-50">
                                        <h2 className="mb-0 start-heading">Get Started!</h2>
                                        {/*No setup fee · No contracts · Cancel anytime*/}
                                        {/*className="mt-0"*/}
                                        <p className="subtitle">Log in to your portal below</p>
                                        {/*<p className="mt-0">Log in to your portal or sign-up for a free 30-day trial</p>*/}
                                        <div className="btn-group mt-30">
                                            <div className="log-in-button">
                                                <Button className="button button-primary" onClick={this.onLogin}>Log In</Button>
                                            </div>
                                            {/*<div className="sign-up-button">*/}
                                            {/*    <Button className="button button-secondary" onClick={this.onSignup}>Sign Up</Button>*/}
                                            {/*</div>*/}
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </Form>
        )
    }
}
export default Main;